import Vue from 'vue'

Vue.filter('timeLineDate', function (str,dayDev) {
  if (str) {
    // let d = new Date(str+(86400*dayDev))
    let d = new Date((str/1000+(86400*dayDev))*1000)
    let weekDay = ["星期天", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];

   let  days = weekDay[d.getDay()];


    // let year = d.getFullYear()
    let month = d.getMonth() + 1
    let day = (d.getDate()) < 10 ? '0' + (d.getDate()) : '' + (d.getDate())
    // let hour = d.getHours()
    // let minutes = d.getMinutes()
    // let seconds = d.getSeconds()
    // return hour + ':' + minutes + ':' + seconds
    // return year + '-' + month + '-' + day + '  ' + hour + ':' + minutes + ':' + seconds
    return  month + '/' + day +'('+days+')'
  } else {
    return ''
  }
})

// 当前时间格式转化
Vue.filter('timeNowDate', function (str) {
    if (str) {
        let d = new Date(str)
        let year = d.getFullYear()
        let month = d.getMonth() + 1
        let day = (d.getDate()) < 10 ? '0' + (d.getDate()) : '' + (d.getDate())
        let hour = d.getHours()< 10 ? '0' + (d.getHours()) : '' + (d.getHours())
        // let minutes = d.getMinutes() < 10 ? '0' + (d.getMinutes()) : '' + (d.getMinutes())
        // let seconds = d.getSeconds() < 10 ? '0' + (d.getSeconds()) : '' + (d.getSeconds())
        // return hour + ':' + minutes + ':' + seconds
        return year + '-' + month + '-' + day + ' ' + hour+ ':00:00'
        // return  month + '/' + day +'('+days+')'
    } else {
        return ''
    }
})


Vue.filter('formatTime', function (time) {
    if (time) {
        if (time >= 0 && time < 60) {
            return time + '秒';
        }
        // 超过1分钟，显示XX分钟
        else if (time >= 60 && time < 3600) {
            return Math.floor(time / 60) + '分钟'+ (time % 60).toFixed(0)  +'秒';
        }
        // 超过1小时，显示xx小时
        else if (time >= 3600 && time < 86400) {
            return Math.floor(time / 3600) + '小时'+(time/60 % 60).toFixed(0)+'分钟' + (time % 60).toFixed(0) +'秒';
        }
        // 时间过长，显示日期和时间
        else {
            var days = Math.floor(time / 86400);
            var hours = Math.floor((time % 86400) / 3600);
            var minutes = Math.floor((time % 3600) / 60);
            var seconds = time % 60;
            return days + '天' + hours + '小时' + minutes + '分' + seconds + '秒';
        }
    } else {
        return '0 秒'
    }
})
